"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBack = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ArrowBack = function ArrowBack() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M5.445 13.44A1.493 1.493 0 015 12.38v-.76c.005-.397.164-.777.445-1.06L15.832.296a1.015 1.015 0 011.434 0l1.435 1.42a.975.975 0 010 1.4L9.71 12l8.992 8.883a.995.995 0 010 1.42l-1.435 1.401a1.015 1.015 0 01-1.434 0L5.445 13.44z"
  });
};

exports.ArrowBack = ArrowBack;